import {
  List,
  Datagrid,
  TextField,
  DeleteButton,
  usePermissions,
} from "react-admin";

import { Typography, Box } from "@mui/material";

const FormTypeList = (props) => {
  const { permissions = [] } = usePermissions();

  const canDelete =
    permissions.includes("forms.delete") ||
    permissions.includes("forms.*") ||
    permissions.includes("*");

  return (
    <List title="Feedback Types" {...props}>
      <Box sx={{ pt: 5, pb: 5 }}>
        <Typography variant="h4" fontWeight={600} align="left">
          Feedback Types
        </Typography>
      </Box>

      <Datagrid bulkActionButtons={false}>
        <TextField source="id" />
        <TextField source="name" label="Form-Type" />

        
      </Datagrid>
    </List>
  );
};

export default FormTypeList;